import axios from 'axios';

// API基础配置 - 修复生产环境URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://lixing-be.onrender.com';

console.log('[API配置] 使用API地址:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  // 添加超时设置
  timeout: 20000, // 增加超时时间
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    console.log('[API请求]', config.method?.toUpperCase(), config.url);
    
    // 在这里可以添加认证token等
    const token = localStorage.getItem('user_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('[API请求错误]', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    console.log('[API响应]', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('[API响应错误]', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message,
      code: error.code,
      isNetworkError: !error.response
    });
    
    // 处理网络错误
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.log('[API重试] 请求超时，尝试重试...');
    }
    
    // 处理CORS错误
    if (error.message.includes('Network Error') || error.code === 'ERR_NETWORK') {
      console.error('[API CORS错误] 可能是跨域问题，请检查后端CORS配置');
    }
    
    // 处理通用错误
    if (error.response?.status === 401) {
      localStorage.removeItem('user_token');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default api; 